import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  TemplateRef,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { causeEffectModelElement } from 'src/app/models/analytical-toolsModels/cause-effectmodel';
import { AnalyticalToolsService } from 'src/app/services/analytical-tools.service';
import { AtHeader } from 'src/app/models/analytical-toolsModels/atHeader';
import { MatCheckbox } from '@angular/material/checkbox';
import { FivewhyService } from 'src/app/services/fivewhy.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { ManagerExecutionService } from '../../services/manager.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from 'src/app/analytical-tools/image-dialog/image-dialog.component';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { CommonService } from 'src/app/services/common.service';
import * as moment from 'moment';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { BaseApi } from 'src/backend/api/base-api';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { Employee } from 'src/backend/models/user/employee';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { WorkFlowService } from 'src/app/services/work-flow.service';
import { NcrService } from 'src/app/services/ncr.service';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { UserService } from 'src/backend/services/user-access-services/user.service';
import { OverallActionPlanService } from 'src/app/services/overall-actionPlan.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { ActionPlanData, ActionPlanConstants } from 'src/app/models/action-plan-data.interface';
@Component({
  selector: 'app-fivewhy-actionplan',
  templateUrl: './fivewhy-actionplan.component.html',
  styleUrls: ['./fivewhy-actionplan.component.scss'],
})
export class FivewhyActionplanComponent implements OnInit {
  newGroupItemParent!: causeEffectModelElement;
  public filteredemployee: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();
  @Output() _emitHeaderData: EventEmitter<any> = new EventEmitter();
  public valueSearchCtrl: FormControl = new FormControl();
  @Output() saveNCRFilesEvent = new EventEmitter<any>();
  @Output() getAtfilesEvent = new EventEmitter<any>();
  callSaveMethod: boolean = false;
  isAnyFileUploaded: boolean;
  groupData: any;
  plantData: string;
  @Input('data')
  set data(data: any) {
    //do whatever you want with your data here, this data will be passed from parent component
    console.log(data);
  }
  @Input() headerID: any;
  @Input() _permission: any;
  ncrWorkFlow: any;
  transitions: any[];
  fiveWhyActionPlan: any;
  causeEffect: any = [];
  stageName: string = '5 Why Action Plan';
  stageId: number = 5;
  breadcrumList!: any;
  spinnerText: string = '';
  headerData: any = {
    ID: 0,
    Group: '',
    Plant: '',
    Dept: '',
    Team: '',
    TeamLeader: '',
    InitProbStatement: '',
    NoOfM: 6,
    stageId: 5,
    uniqueCode: '',
    CreatedAt: new Date(),
    CreatedBy: '',
  };
  user: any;
  rcaId: number = 0;
  updateStatus: boolean = false;
  blobStorageUrl = Constants.BLOB_STORAGE_URL;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatCheckbox) checkbox!: MatCheckbox;

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInputFile') fileInputFile!: ElementRef;
  @Input() actionPlan_: EventEmitter<any> = new EventEmitter();
  @Input() headerData_: EventEmitter<any> = new EventEmitter();
  imageFile: any;
  imageSrc: any;
  ImageUrl: any;
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;

  // causeEffectModelColumns: string[] = ['RootCause', 'Action', 'ActionType', 'Picture', 'File', 'AssignTo', 'AssignedDate', 'TargetDate', 'RevisedDate', 'No Of Misses', 'ActionCompleted (Yes/No)', 'ActionCompleted (By & On)', 'Verification (Approved / Disapproved)', 'Verification (By & On)', 'New Assignee', 'ClosedDate', 'Remarks', 'Verified', 'VerifiedBy', 'Status', '', ''];

  causeEffectModelColumns: string[];
  protected _onDestroy = new Subject<void>();
  fiveWhy: any = [];
  userList: any = [];
  filteredUserList: any = [];
  filteredVerifyUserList: any = [];

  fiveWhyActionPlanDataSource = new MatTableDataSource();
  formData: any = [];
  levelId: number = 5;
  isReset: boolean = false;
  FileList: any = [];
  FileData: any = [];
  ind: any = 0;
  UploadFile: any = [];
  IndividualFivewhyID: number = 0;
  permisson!: any;
  IsAccess!: any;
  orgfiveWhy: any = [];
  userAllList: any = [];

  newUserList: any = [];
  newUserFiltList: any = [];
  newOrgUserList: any = [];
  newOrgUserFiltList: any = [];
  sub: Subscription;
  cycleStatuses: any;
  teamList: any = [];
  CriticalityLevels = [
    { name: 'High', value: 3 },
    { name: 'Medium', value: 2 },
    { name: 'Low', value: 1 },
  ];

  ActionTypes = [
    { value: 'Preventive', checked: true },
    { value: 'Corrective', checked: false },
  ];
  teamListTemp: any = [];
  employees: Employee[] = [];
  employeesTemp: Employee[] = [];
  isAccess = ApplicationPermission.ANALYTICAL_TOOLS_ACCESS;
  isCreate = ApplicationPermission.ANALYTICAL_TOOLS_CREATE;
  isUpdate = ApplicationPermission.ANALYTICAL_TOOLS_UPDATE;
  isDelete = ApplicationPermission.ANALYTICAL_TOOLS_DELETE;
  mClassificationTypes: any[] = [];
  constructor(
    public managerExecutionService: ManagerExecutionService,
    private FivewhyService: FivewhyService,
    private domSanitizer: DomSanitizer,
    private userService: UserService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    public router: Router,
    private analyticalToolsService: AnalyticalToolsService,
    private route: ActivatedRoute,
    private userManagementService: UserManagementService,
    private dialog: MatDialog,
    private enterpriseGroupService: EnterPriseGroupService,
    private commonService: CommonService,
    private dataService: DataService,
    private baseApi: BaseApi,
    private employeeService: EmployeeService,
    private workFlowService: WorkFlowService,
    private ncrService: NcrService,
    private actionplanService: OverallActionPlanService,
    private fileUploadService: FileUploadService
  ) { }

  replaceIcon(value: any): any {
    return value.replace(/(<([^>]+)>)/gi, '');
  }

  ngOnInit(): void {
    this.getMClassificationList();
    // this.sub = this.actionPlan_.subscribe((event: any) => {
    //   console.log(event);
    //   this.saveFiveWhyPlan(event);
    // });
    let processed = false;

    this.sub = this.actionPlan_.subscribe((event: any) => {
      if (!processed) {
        this.saveFiveWhyPlan(event);
        // processed = true;
      }
    });

    window.scrollTo(0, 0);
    this.getAllUserList();
    this.dataService.getData().subscribe((value: any) => {
      this.headerData = value;
    });
    this.groupData = this.baseApi.getGroupFromStorage();
    this.plantData = this.baseApi.getPlantCodeFromStorage();
    this.permisson = this._permission;
    //this.GetBreadcrumList();
    this.getEmployeesByPlant();
    //this.GetMenuAccess();
    this.user = this.baseApi.getUserSession();
    this.headerData.CreatedBy = this.user.userCode;
    const userGroup = this.analyticalToolsService.getUserGroup();
    if (userGroup) this.headerData.Group = userGroup;
    this.fiveWhyActionPlanDataSource = new MatTableDataSource(this.fiveWhy);
    this.headerData.ID = this.headerID;
    // if ((this.analyticalToolsService.getTableId() || 0) > 0) {
      this.getNCRWorkFlow();
    // }
    this.valueSearchCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterValue();
      });
  }
  createColumns() {
    let columns = [
      'Root Cause',
      'Action',
      'Criticality Level',
      'M Classification',
      'Action Type',
      'Picture (jpg,png,jpeg)',
      'File (pdf,doc)',
      'Assign To',
      'Assigned Date',
      'Target Date',
      'Revised Date',
      'No Of Misses',
      'Action Completed (Yes/No)',
      'Action Completed (By & On)',
      'Verification (Approved / Disapproved)',
      'Verified (By & On)',
      'New Assignee',
      'Closed Date',
      'Remarks',
      'Status',
      'Actions',
    ];
    let route: any = this.router.url;
    route = route.split('/');
    route = route.pop();
    const limitedColumns = ['MeetingMatrixV2', 'Scorecard', 'MeetingMatrix'];
    if (limitedColumns.includes(route)) {
      console.log(this.cycleStatuses);
      // if (this.cycleStatuses.StatusCycle === 'InProgress') {
      //   this.causeEffectModelColumns = columns;
      // } else
      if (this.cycleStatuses.StatusCycle === 'Completed') {
        this.causeEffectModelColumns = columns;
      } else {
        this.causeEffectModelColumns = [
          'Root Cause',
          'Action',
          'Criticality Level',
          'M Classification',
          'Action Type',
          'Picture (jpg,png,jpeg)',
          'File (pdf,doc)',
          'Assign To',
          'Target Date',
          'Actions',
        ];
      }
    } else {
      this.causeEffectModelColumns = columns;
    }

    console.log(this.causeEffectModelColumns);
  }

  createFiveWhy() {
    let route = this.router.url;
    if (route.includes('KPIGapAnalysis')) {
      this.fiveWhy = [
        {
          fiveWhyId: 1,
          RootCause: '',
          Action: '',
          PriorityLevel: 1,
          ActionType: 'Preventive',
          AssignTo: '',
          NewAssignee: '',
          AssignedDate: null,
          TargetDate: null,
          RevisedDate: null,
          NoOfMisses: 0,
          ActionCompleted: 'No',
          ActionCompletedBy: '',
          ActionCompletedOn: null,
          Verification: '',
          VerificationBy: '',
          VerificationOn: null,
          ClosedDate: null,
          Status: 'Open',
          VerifiedBy: '',
        },
      ];
      this.levelId = 0;
    } else {
      if (
        this.fiveWhyActionPlan.StatusFiveWhy !== 'InProgress' &&
        this.fiveWhyActionPlan.StatusFiveWhy !== 'Completed'
      ) {
        this.fiveWhy = [
          {
            fiveWhyId: 1,
            RootCause: '',
            Action: '',
            PriorityLevel: 1,
            ActionType: 'Preventive',
            AssignTo: '',
            NewAssignee: '',
            AssignedDate: null,
            TargetDate: null,
            RevisedDate: null,
            NoOfMisses: 0,
            ActionCompleted: 'No',
            ActionCompletedBy: '',
            ActionCompletedOn: null,
            Verification: '',
            VerificationBy: '',
            VerificationOn: null,
            ClosedDate: null,
            Status: 'Open',
            VerifiedBy: '',
          },
        ];
        this.levelId = 0;
      }
    }
  }

  onDatePickerOpen(isOpen: boolean): void {
    if (isOpen) {
      this.setDatePickerZindex();
    }
  }

  setDatePickerZindex(): void {
    const overlayContainers = document.querySelectorAll(
      '.cdk-overlay-container'
    );

    overlayContainers.forEach((container) => {
      const hasDialogInside =
        container.querySelector('mat-dialog-container') !== null;

      if (!hasDialogInside) {
        (container as HTMLElement).style.setProperty(
          'z-index',
          '9999',
          'important'
        );
      }
    });
  }

  showRemainingColumns() {
    let route: any = this.router.url;
    route = route.split('/');
    route = route.pop();
    const limitedColumns = ['MeetingMatrixV2', 'Scorecard', 'MeetingMatrix'];
    if (limitedColumns.includes(route)) {
      // if (this.cycleStatuses.StatusCycle === 'InProgress') {
      //   return true;
      // }
      return false;
    } else {
      return true;
    }
  }
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    this.spinnerText = 'Loading Menu Data';
    // this.spinner.show();
    this.userManagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        // this.spinner.hide();
        this.breadcrumList = data.BreadcrumList;
        console.log(data.BreadcrumList);
      },
      (error) => {
        // this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.permisson = data;
        this.IsAccess = data.IsAccess;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  getFiveWhyActionPlan(reset: any): any {
    this.spinnerText = 'Fetching Five Why Plan Data';
    this.spinner.show();
    const data = { headerId: this.analyticalToolsService.getHeaderId() || 0 };
    this.FivewhyService.getFiveWhyPlanData(data).subscribe(
      (res: any) => {
        console.log(res);
        this.spinner.hide();
        this.updateStatus = res.updateStatus;
        this.levelId = res && res.stageId ? res.stageId : 0;
        this.analyticalToolsService.setTeamLeaderList(res.Team);
        this.rcaId = res.rcaId ? res.rcaId : 0;

        delete res.rcaId;

        if (res.ID) {
          this.headerData = res;
        } else console.log(this.headerData);
        // this.analyticalToolsService.setHeaderId(this.headerData.ID);
        this.analyticalToolsService.setRcaId(this.rcaId);
        this.analyticalToolsService.setLevelId(this.levelId);
        this.analyticalToolsService.setStatus(this.updateStatus);

        this.cycleStatuses = res;
        if (res.fiveWhyActionPlan?.length) {
          this.fiveWhy = res.fiveWhy;
          this.fiveWhyActionPlan = res.fiveWhyActionPlan?.map((action) => {
            // Add hasCompletedActions property - true only for existing completed records
            action.hasCompletedActions = Boolean(action.ID && action.ActionCompleted === 'Yes');
            
            // Track original status and verification for detection of changes
            action.originalStatus = action.Status;
            action.hasClosedActions = Boolean(action.ID && action.Status === 'Closed');
            action.originalVerification = action.Verification;
            action.hasRejectedActions = Boolean(action.ID && action.Verification === 'Rejected');
            action.originalNewAssignee = action.NewAssignee;
            action.hasNewAssigneeAdded = Boolean(action.ID && action.NewAssignee);
            action.Verification = action.Verification ?? '';

            // Set MClassification from fiveWhy.TypeOfM if not already set
            if ((action.MClassification === null || action.MClassification === undefined)) {
              let typeOfM = null;

              // Try to get TypeOfM from nested fiveWhy object first
              if (action.fiveWhy && action.fiveWhy?.TypeOfM) {
                typeOfM = action.fiveWhy.TypeOfM;
              }
              // Fallback to matching from fiveWhy array
              else if (action.fiveWhyId) {
                const matchingFiveWhy = this.fiveWhy?.find(
                  (f) => f.ID === action.fiveWhyId
                );
                if (matchingFiveWhy && matchingFiveWhy.TypeOfM) {
                  typeOfM = matchingFiveWhy.TypeOfM;
                }
              }

              // Find the matching Id from mClassificationTypes by Name
              if (typeOfM && this.mClassificationTypes && this.mClassificationTypes.length) {
                const matchingType = this.mClassificationTypes.find(
                  (type) => type.Name === typeOfM
                );
                if (matchingType) {
                  action.MClassification = matchingType.Id;
                }
              }
            } else if (action.MClassification) {
              action.MClassification = +action.MClassification; // convert if not null
            }
            return action;
          });

          console.log('this.fiveWhyActionPlan', this.fiveWhyActionPlan);
          this.fiveWhy = res.fiveWhyActionPlan;
        } else {
          this.createFiveWhy();
        }
        this.createColumns();
        if (this.levelId != 0 && this.levelId != 5) {
          if (this.fiveWhy && this.fiveWhy.length) {
            const actionplan = this.fiveWhy.filter(
              (fiveY: any) => fiveY.RootCause != ''
            );
            this.fiveWhy = actionplan && actionplan.length ? actionplan : [];
            this.orgfiveWhy = this.fiveWhy;
          }
          if (this.IndividualFivewhyID) {
            const actionplan = this.fiveWhy.filter(
              (fiveY: any) => fiveY.fiveWhyId == this.IndividualFivewhyID
            );
            this.fiveWhy = actionplan && actionplan.length ? actionplan : [];
          }
        } else {
          if (this.fiveWhy && this.fiveWhy.length == 1) {
            this.fiveWhy[0].MainRowShow = true;
          }
          this.orgfiveWhy = this.fiveWhy;
        }

        if (this.levelId == 0 || this.levelId == 5) {
          if (this.fiveWhy && this.fiveWhy.length && this.fiveWhy.length > 1) {
            this.setFyActionSort();
          }
        }

        for (const fya of this.fiveWhy) {
          fya['base64'] = '';
          const mRecords = this.fiveWhy.filter(
            (fiveY: any) => fya.fiveWhyId == fiveY.fiveWhyId
          );
          // if (mRecords && mRecords.length) {
          //   let disabled = mRecords.map((rec: any, index: number) => {
          //     if (index == 0){
          //       rec.rowSpan = mRecords && mRecords.length ? mRecords.length : 1;
          //     }
          //     else {
          //       rec.spanRow = true;
          //     }
          //   });
          // }
          fya.PriorityLevel = fya.PriorityLevel ? fya.PriorityLevel : 1;
          fya.NoOfMisses = fya.NoOfMisses ? fya.NoOfMisses : 0;
          fya.MissesCondition = true;

          if (fya.Status == 'InProgress') {
            let currentDate: any = new Date();
            let targetDate: any = new Date(fya.TargetDate);
            currentDate = moment(currentDate).format('YYYY-MM-DD');
            targetDate = moment(targetDate).format('YYYY-MM-DD');
            if (currentDate > targetDate) {
              fya.Status = 'Delayed';
              fya.NoOfMisses = 1;
            }
          }
          fya.ActionCompleted = fya.ActionCompleted == 'Yes' ? 'Yes' : 'No';
          if (fya.Status !== 'Closed') {
            this.ActionTypes.forEach((action, index) => {
              this.ActionTypes[index] = {
                ...action,
                checked: action.value === fya.ActionType,
              };
            });
          }
          // if (fya.Status !== 'Closed') {
          //   this.ActionTypes.forEach(action => {
          //     action.checked = action.value === fya.ActionType;
          //   });
          // }
        }

        // let a = this.fiveWhy.filter((obj: any) => !obj.spanRow);
        // if (a && a.length) {
        //   for (let index = 0; index < a.length; index++) {
        //     if (index == a.length - 1) a[index].MainRowShow = true;
        //     else a[index].MainRowShow = false;
        //   }
        // }

        if (reset == 'reset' && !this.headerData.ID) this.resetData();
        setTimeout(() => {
          this.getUserList();
        }, 1500);

        // Update assignment flags for all rows after data is loaded
        this.updateAllRowsAssignmentFlags();

        this.fiveWhyActionPlanDataSource = new MatTableDataSource(this.fiveWhy);
        if (this.headerID !== 0) {
          this.getAtfilesEvent.emit();
        }
        if (this.headerID !== 0 && this.callSaveMethod == true) {
          this.saveNCRFilesEvent.emit();
          const files = this.fileUploadService.getFiles();
          if (files.length > 0) {
            this.fileUploadService.saveNCRFiles(this.headerData.ID);
          } else {
            console.error('No files available for saving.');
          }
        }
      },
      (error) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.spinner.show();
    console.log(this.headerData);
    // this.headerData = this._headerData;
    const data = {
      groupCode: this.headerData?.group || this.headerData?.Group,
      plantCode: this.headerData?.plant || this.headerData?.Plant,
    };

    this.commonService.getPeopleMasterData(data).subscribe(
      (res: any) => {
        console.log(res);
        if (!res.HasError) {
          // this.orgMachineryList.map((machinery: any) => this.machineryList.push([...this.mList.machineryList]));
          this.userList = res.employeeInfoList;
          this.userList.map(
            (user: any) =>
              (user.fullName = user.FirstName + ' ' + user.lastName)
          );

          this.filteredUserList = this.userList.slice();
          this.filteredVerifyUserList = this.userList.slice();

          this.fiveWhy.map((orgUser: any) =>
            this.newUserList.push([...this.userList])
          );
          this.fiveWhy.map((orgUser: any) =>
            this.newOrgUserList.push([...this.userList])
          );
          this.newUserFiltList =
            this.newUserList && this.newUserList.length
              ? this.newUserList.slice()
              : [];
          this.newOrgUserFiltList =
            this.newOrgUserList && this.newOrgUserList.length
              ? this.newOrgUserList.slice()
              : [];
          console.log(this.newUserFiltList);
        }
        this.spinner.hide();
      },
      (err: any) => {
        console.log(err);
        this.spinner.hide();
      }
    );
  }

  searchValues(filter: any, index: number, type: any) {
    filter = filter.target.value;
    if (type == 'assignTo') {
      this.newUserList[index] = this.userList.filter((user: any) => {
        let lowerCase = user.fullName.toLocaleLowerCase();
        return user.fullName.startsWith(filter) || lowerCase.startsWith(filter);
      });
    } else if (type == 'newAssignee') {
      this.newOrgUserList[index] = this.userList.filter((user: any) => {
        let lowerCase = user.fullName.toLocaleLowerCase();
        return user.fullName.startsWith(filter) || lowerCase.startsWith(filter);
      });
    }
  }

  getEmployeesByPlant() {
    this.spinner.show();
    this.employeeService.getAllEmployees().subscribe(
      (res: any) => {
        this.employees = res;
        this.employeesTemp = this.employees.slice();
        this.filteredemployee.next(this.employeesTemp);
        this.getFiveWhyActionPlan('');
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }
  filterValue(): void {
    if (!this.employeesTemp) {
      return;
    }
    let search = this.valueSearchCtrl.value;
    if (!search) {
      this.filteredemployee.next(this.employeesTemp);
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredemployee.next(
      this.employeesTemp.filter(
        (value: any) => value.fullName.toLowerCase().indexOf(search) > -1
      )
    );
  }

  getAllUserList() {
    // this.spinnerText = "Fetching User Data";
    this.spinner.show();

    this.userService.getUsersByPlant().subscribe(
      (res: any) => {
        this.userAllList = res;
        this.spinner.hide();
        // this.getFiveWhyActionPlan('');
      },
      (err: any) => {
        console.log(err);
        this.spinner.hide();
      }
    );
  }

  setSort() {
    this.fiveWhy.sort(function (a: any, b: any) {
      return a.fiveWhyId - b.fiveWhyId;
    });
  }

  setFyActionSort() {
    let i = 1;
    for (const fya of this.fiveWhy) {
      let arr = this.fiveWhy.filter(
        (fiveY: any) => fiveY.FyActionId == fya.FyActionId
      );
      if (arr && arr.length && !fya.fiveWhyId) {
        arr.map((cause: any, index: number) => {
          cause.fiveWhyId = i;
        });
        i++;
      }
    }
    this.fiveWhy.map((cause: any, index: number) => {
      delete cause.FyActionId;
    });
  }

  addRow(element: any, i: number, type: any) {
    let obj: any;
    if (type == 'sub') {
      obj = {
        fiveWhyId: element.fiveWhyId,
        RootCause: element.RootCause,
        Action: '',
        MClassification: element.MClassification,
        PriorityLevel: element.PriorityLevel,
        ActionType: element.ActionType,
        AssignTo: '',
        NewAssignee: '',
        AssignedDate: null,
        TargetDate: null,
        RevisedDate: null,
        NoOfMisses: 0,
        ActionCompleted: 'No',
        ActionCompletedBy: '',
        ActionCompletedOn: null,
        Verification: '',
        VerificationBy: '',
        VerificationOn: null,
        ClosedDate: null,
        Status: 'Open',
        VerifiedBy: '',
        FromActionPlan: true,
        // Initialize tracking properties for new actions
        hasCompletedActions: false,
        hasClosedActions: false,
        hasRejectedActions: false,
        hasNewAssigneeAdded: false,
        originalStatus: 'Open',
        originalVerification: '',
        originalNewAssignee: '',
        isNewlyCompleted: false,
        isNewlyClosed: false,
        isNewlyRejected: false,
        isNewlyReassigned: false
      };
      obj.MainRowShow = false;
    } else if (type == 'main') {
      obj = {
        fiveWhyId: element.fiveWhyId,
        fiveWhy: element.fiveWhy,
        RootCause: '',
        Action: '',
        isNewRow: true,
        MClassification: element.MClassification,
        PriorityLevel: element.PriorityLevel,
        ActionType: element.ActionType,
        AssignTo: '',
        NewAssignee: '',
        AssignedDate: null,
        TargetDate: null,
        RevisedDate: null,
        NoOfMisses: 0,
        ActionCompleted: 'No',
        ActionCompletedBy: '',
        ActionCompletedOn: null,
        Verification: '',
        VerificationBy: '',
        VerificationOn: null,
        ClosedDate: null,
        Status: 'Open',
        VerifiedBy: '',
        FromActionPlan: true,
        // Initialize tracking properties for new actions
        hasCompletedActions: false,
        hasClosedActions: false,
        hasRejectedActions: false,
        hasNewAssigneeAdded: false,
        originalStatus: 'Open',
        originalVerification: '',
        originalNewAssignee: '',
        isNewlyCompleted: false,
        isNewlyClosed: false,
        isNewlyRejected: false,
        isNewlyReassigned: false
      };
    }
    // this.fiveWhy.push({ Action: element.Action, ActionType: element.ActionType, AssignTo: element.AssignTo, TargetDate: element.TargetDate, RevisedDate: element.RevisedDate, ClosedDate: element.ClosedDate, Status: element.Status, VerifiedBy: element.VerifiedBy, FromActionPlan:true});
    this.fiveWhy.splice(i + 1, 0, obj);
    console.log(obj, 'bigo');
    this.setSort();

    // for (const fya of this.fiveWhy) {
    //   const mRecords = this.fiveWhy.filter(
    //     (fiveY: any) => fya.fiveWhyId == fiveY.fiveWhyId
    //   );
    //   if (mRecords && mRecords.length) {
    //     let disabled = mRecords.map((rec: any, index: number) => {
    //       if (index == 0)
    //         rec.rowSpan = mRecords && mRecords.length ? mRecords.length : 1;
    //       else {
    //         rec.spanRow = true;
    //       }
    //     });
    //   }
    // }
    let a = this.fiveWhy.filter((obj: any) => !obj.spanRow);
    if (a && a.length) {
      for (let index = 0; index < a.length; index++) {
        if (index == a.length - 1) a[index].MainRowShow = true;
        else a[index].MainRowShow = false;
      }
    }
    this.newUserList = [];
    this.newOrgUserList = [];
    this.fiveWhy.map((orgUser: any) =>
      this.newUserList.push([...this.userList])
    );
    this.fiveWhy.map((orgUser: any) =>
      this.newOrgUserList.push([...this.userList])
    );
    this.newUserFiltList =
      this.newUserList && this.newUserList.length
        ? this.newUserList.slice()
        : [];
    this.newOrgUserFiltList =
      this.newOrgUserList && this.newOrgUserList.length
        ? this.newOrgUserList.slice()
        : [];
    this.fiveWhyActionPlanDataSource = new MatTableDataSource(this.fiveWhy);
  }
  deleteRow(i: any) {
    if (this.levelId == 0 || this.levelId == 5) {
      const isHaveSub = this.fiveWhy.filter(
        (cause: any) => cause.fiveWhyId == this.fiveWhy[i].fiveWhyId
      );
      // if (isHaveSub && isHaveSub.length > 1 && !this.fiveWhy[i].spanRow) {
      //   this.toaster.warning('Warning', `Remove sub row for this row`);
      //   return;
      // }
    }
    this.fiveWhy.splice(i, 1);
    // for (const fya of this.fiveWhy) {
    //   const mRecords = this.fiveWhy.filter(
    //     (fiveY: any) => fya.fiveWhyId == fiveY.fiveWhyId
    //   );
    //   if (mRecords && mRecords.length) {
    //     let disabled = mRecords.map((rec: any, index: number) => {
    //       if (index == 0)
    //         rec.rowSpan = mRecords && mRecords.length ? mRecords.length : 1;
    //       else {
    //         rec.spanRow = true;
    //       }
    //     });
    //   }
    // }
    let b = this.fiveWhy.filter((obj: any) => !obj.spanRow);
    if (b && b.length) {
      for (let index = 0; index < b.length; index++) {
        if (index == b.length - 1) b[index].MainRowShow = true;
        else b[index].MainRowShow = false;
      }
    }
    this.newUserList = [];
    this.newOrgUserList = [];
    this.fiveWhy.map((orgUser: any) =>
      this.newUserList.push([...this.userList])
    );
    this.fiveWhy.map((orgUser: any) =>
      this.newOrgUserList.push([...this.userList])
    );
    this.newUserFiltList =
      this.newUserList && this.newUserList.length
        ? this.newUserList.slice()
        : [];
    this.newOrgUserFiltList =
      this.newOrgUserList && this.newOrgUserList.length
        ? this.newOrgUserList.slice()
        : [];
    this.fiveWhyActionPlanDataSource = new MatTableDataSource(this.fiveWhy);
  }

  isChecked(event: any, row: any) {
    if (event.checked) {
      row.VerifiedBy = this.user.userCode;
    } else {
      row.VerifiedBy = null;
    }
  }

  getUserName(row: any, type: any) {
    if (type == 'actionBy') {
      let objFindName = this.userAllList.find(
        (usr: any) => usr.userCode == row.ActionCompletedBy
      );
      if (objFindName) return objFindName.fullName;
      else if (row.ActionCompletedBy == 100001) return 'Admin';
      else return null;
    } else if (type == 'verificationBy') {
      let objFindName = this.userAllList.find(
        (usr: any) => usr.userCode == row.VerificationBy
      );
      if (objFindName) return objFindName.fullName;
      else if (row.VerificationBy == 100001) return 'Admin';
      else return null;
    } else if (type == 'verifiedBy') {
      let objFindName = this.userAllList.find(
        (usr: any) => usr.userCode == row.VerifiedBy
      );
      if (objFindName) return objFindName.fullName;
      else if (row.VerifiedBy == 100001) return 'Admin';
      else return null;
    }
  }

  getFileTypeName(val: any) {
    if (val && typeof val === 'string') {
      let arr = val.split('.');
      if (arr && arr.length && arr.length != 1)
        return `( ${arr[arr.length - 1]} )`;
      // else if (arr.length == 1) {
      //   arr = val.split(';');
      //   arr = arr[0].split('/');
      //   return `( ${arr[arr.length - 1]} )`;
      // }
      else return ``;
    }
  }

  resetData() {
    console.log('truggered');
    this.headerData = {
      ID: 0,
      Group: '',
      Plant: '',
      Dept: '',
      Team: '',
      TeamLeader: '',
      InitProbStatement: '',
      NoOfM: 6,
      stageId: 5,
      uniqueCode: '',
      CreatedAt: new Date(),
      CreatedBy: this.user.userCode,
    };
    this.isReset = true;
    this.analyticalToolsService.setRca(false);
    this.analyticalToolsService.setRcaId(0);
    this.analyticalToolsService.setHeaderId(0);
    this.analyticalToolsService.setFilteredIndex(0);
    this.analyticalToolsService.setFilteredData([]);
    this.analyticalToolsService.setTeamLeaderList([]);
    this.getFiveWhyActionPlan('');
  }

  saveFiveWhyPlan(e: any) {
    let event = e.headerData;
    let integrationData = e.integrationData;
    let statusCheck = false;
    delete event?.stageID;
    delete event?.CauseFileCount;

    // const checkRemark = this.fiveWhy?.find(
    //   (el: any) => el.RevisedDate && !el.Remarks
    // );
    // if (checkRemark) {
    //   this.toaster.warning(
    //     'Warning',
    //     `Please Fill The Remarks Field For Rootcause ${checkRemark.RootCause}`
    //   );
    //   return;
    // }

    // Check for mandatory remarks when verification is disapproved
    const checkDisapprovedRemark = this.fiveWhy?.find(
      (el: any) => el.Verification === 'Disapproved' && (!el.Remarks || el.Remarks.trim() === '')
    );
    if (checkDisapprovedRemark) {
      this.toaster.warning(
        'Warning',
        `Please Fill The Remarks Field For Rootcause ${checkDisapprovedRemark.RootCause}`
      );
      return;
    }

    // Track newly completed, newly closed, newly rejected, and newly added assignee actions for notifications
    const newlyCompletedActions: any[] = [];
    const newlyClosedActions: any[] = [];
    const newlyRejectedActions: any[] = [];
    const newlyAddedAssigneeActions: any[] = [];

    for (const fiveWhy of this.fiveWhy) {
      // if (fiveWhy.RevisedDate && !fiveWhy.Remarks) {
      //   this.toaster.warning('Warning', `Please Fill The Remarks Field For Rootcause ${fiveWhy.RootCause}`);
      //   return;
      // }
      delete fiveWhy.FileSrc;
      delete fiveWhy.DocSrc;
      delete fiveWhy.minRevisedDate;
      delete fiveWhy.MinTargetDate;
      delete fiveWhy.rowSpan;
      delete fiveWhy.spanRow;
      
      // Check if this action is newly completed (not completed before but completed now)
      const isNewlyCompleted = fiveWhy.ActionCompleted === 'Yes' && !fiveWhy.hasCompletedActions;
      if (isNewlyCompleted) {
        newlyCompletedActions.push(fiveWhy);
      }
      
      // Check if this action is newly closed (not closed before but closed now)
      // This covers both manual closure and approval-based closure
      const isNewlyClosed = fiveWhy.Status === 'Closed' && !fiveWhy.hasClosedActions;
      if (isNewlyClosed) {
        newlyClosedActions.push(fiveWhy);
      }
      
      // Check if this action is newly rejected (not rejected before but rejected now)
      const isNewlyRejected = fiveWhy.Verification === 'Rejected' && !fiveWhy.hasRejectedActions;
      if (isNewlyRejected) {
        newlyRejectedActions.push(fiveWhy);
      }
      
      // Check if new assignee was added/changed
      // Case 1: First time assignment (newly added newassignee)
      const isNewAssigneeFirstTime = fiveWhy.ID && // Must have ID (existing action)
                                   fiveWhy.NewAssignee && 
                                   !fiveWhy.originalNewAssignee && // No previous value (first time assignment)
                                   fiveWhy.NewAssignee !== fiveWhy.AssignTo;
      
      // Case 2: Changed assignment (existing newassignee changed to different person)
      const isNewAssigneeChanged = fiveWhy.ID && // Must have ID (existing action)
                                 fiveWhy.NewAssignee && 
                                 fiveWhy.originalNewAssignee && // Must have had a previous value
                                 fiveWhy.NewAssignee !== fiveWhy.originalNewAssignee &&
                                 fiveWhy.NewAssignee !== fiveWhy.AssignTo;
      
      const isNewAssigneeAdded = isNewAssigneeFirstTime || isNewAssigneeChanged;
      if (isNewAssigneeAdded) {
        newlyAddedAssigneeActions.push(fiveWhy);
      }
      
      // Set the flags for each action to be sent to backend
      fiveWhy.isNewlyCompleted = isNewlyCompleted;
      fiveWhy.isNewlyClosed = isNewlyClosed;
      fiveWhy.isNewlyRejected = isNewlyRejected;
      fiveWhy.isNewlyReassigned = isNewAssigneeAdded; // Covers both first-time and changed assignments
      
      // Update state tracking properties
      fiveWhy.hasCompletedActions = Boolean(fiveWhy.ID && fiveWhy.ActionCompleted === 'Yes');
      fiveWhy.hasClosedActions = Boolean(fiveWhy.ID && fiveWhy.Status === 'Closed');
      fiveWhy.hasRejectedActions = Boolean(fiveWhy.ID && fiveWhy.Verification === 'Rejected');
      fiveWhy.hasNewAssigneeAdded = Boolean(fiveWhy.ID && fiveWhy.NewAssignee);
      
       fiveWhy.CreatedBy = fiveWhy.CreatedBy ? fiveWhy.CreatedBy : this.user.userCode;
      

      if (this.levelId == 0 || this.levelId == 5) {
        delete fiveWhy.MainRowShow;
        fiveWhy.FyActionId = fiveWhy.fiveWhyId;
        fiveWhy.fiveWhyId = null;
      }
      fiveWhy.AssignTo = fiveWhy.AssignTo == '' ? null : fiveWhy.AssignTo;
      fiveWhy.PriorityLevel = fiveWhy.PriorityLevel ? fiveWhy.PriorityLevel : 1;
      fiveWhy.NewAssignee =
        fiveWhy.NewAssignee == '' ? null : fiveWhy.NewAssignee;
      fiveWhy.VerifiedBy =
        fiveWhy.VerificationBy == '' ? null : fiveWhy.VerificationBy;
      fiveWhy.ActionCompletedBy =
        fiveWhy.ActionCompletedBy == '' ? null : fiveWhy.ActionCompletedBy;
      fiveWhy.VerificationBy =
        fiveWhy.VerificationBy == '' ? null : fiveWhy.VerificationBy;

      if (fiveWhy.TargetDate) {
        fiveWhy.TargetDate = new Date(fiveWhy.TargetDate);
        fiveWhy.TargetDate.setHours(new Date().getHours());
        fiveWhy.TargetDate.setMinutes(new Date().getMinutes());
        fiveWhy.TargetDate.setSeconds(new Date().getSeconds());
      }
      if (fiveWhy.AssignedDate) {
        fiveWhy.AssignedDate = new Date(fiveWhy.AssignedDate);
        fiveWhy.AssignedDate.setHours(new Date().getHours());
        fiveWhy.AssignedDate.setMinutes(new Date().getMinutes());
        fiveWhy.AssignedDate.setSeconds(new Date().getSeconds());
      }
      if (fiveWhy.RevisedDate) {
        fiveWhy.RevisedDate = new Date(fiveWhy.RevisedDate);
        fiveWhy.RevisedDate.setHours(new Date().getHours());
        fiveWhy.RevisedDate.setMinutes(new Date().getMinutes());
        fiveWhy.RevisedDate.setSeconds(new Date().getSeconds());
      }
      if (fiveWhy.ClosedDate) {
        fiveWhy.ClosedDate = new Date(fiveWhy.ClosedDate);
        fiveWhy.ClosedDate.setHours(new Date().getHours());
        fiveWhy.ClosedDate.setMinutes(new Date().getMinutes());
        fiveWhy.ClosedDate.setSeconds(new Date().getSeconds());
      }

      fiveWhy.Status =
        fiveWhy.TargetDate && !fiveWhy.RevisedDate
          ? 'InProgress'
          : fiveWhy.TargetDate && fiveWhy.RevisedDate
            ? 'Delayed'
            : 'Open';
      if (fiveWhy.ActionCompleted == 'Yes') {
        fiveWhy.Status = 'Complete';
      }
      if (fiveWhy.Verification == 'Approved') {
        fiveWhy.Status = 'Closed';
        fiveWhy.ClosedDate = new Date();
      } else if (fiveWhy.Verification == 'Disapproved') {
        fiveWhy.Status = 'ReOpened';
        fiveWhy.ActionCompleted = 'No';
      }

      if (fiveWhy.Status != 'Closed') statusCheck = true;
    }

    const closecheck = this.orgfiveWhy.some((el: any) => el.Status != 'Closed');
    if (closecheck) statusCheck = true;

    if (event?.StatusFiveWhy && event?.StatusFiveWhy == 'InProgress') {
      let found: any;
      if (this.levelId == 0 || this.levelId == 5)
        found = this.orgfiveWhy.some(
          (el: any) =>
            el.RootCause ||
            el.Action ||
            el.AssignTo ||
            el.TargetDate ||
            el.Verification
        );
      else
        found = this.orgfiveWhy.some(
          (el: any) =>
            el.Action || el.AssignTo || el.TargetDate || el.Verification
        );

      if (!found) event.StatusFiveWhyAction = 'Open';
      else event.StatusFiveWhyAction = 'InProgress';
    } else {
      // const found = this.orgfiveWhy.some((el: any) => el.Action || el.AssignTo || el.TargetDate || el.Verification);

      let found: any;
      if (this.levelId == 0 || this.levelId == 5)
        found = this.orgfiveWhy.some(
          (el: any) =>
            el.RootCause ||
            el.Action ||
            el.AssignTo ||
            el.TargetDate ||
            el.Verification
        );
      else
        found = this.orgfiveWhy.some(
          (el: any) =>
            el.Action || el.AssignTo || el.TargetDate || el.Verification
        );

      if (!found) event.StatusFiveWhyAction = 'Open';
      else if (statusCheck) event.StatusFiveWhyAction = 'InProgress';
      else if (!statusCheck) event.StatusFiveWhyAction = 'Completed';
    }

    if (statusCheck) {
      let completeArr = this.orgfiveWhy.filter(
        (el: any) => el.Status != 'Closed'
      );
      const completecheck = completeArr.every(
        (el: any) => el.Status == 'Complete'
      );
      if (completecheck) {
        if (event.StatusFiveWhy == 'Completed') event.StatusCycle = 'NotClosed';
        else event.StatusCycle = 'InProgress';
      } else event.StatusCycle = 'InProgress';
    }

    const delaycheck = this.orgfiveWhy.some(
      (el: any) => el.Status == 'Delayed' || el.Status == 'ReOpened'
    );
    if (delaycheck) event.StatusCycle = 'Delayed';

    // let FiveWhy = {
    //   headerId: this.headerData.ID,
    //   createdBy: this.user.userCode,
    //   data: this.fiveWhy
    // };
    delete event.fiveWhy;
    delete event.causeAndEffects;
    delete event.fiveWhyActionPlan;
    delete event.updateStatus;
    delete event.hasRca;
    delete event.uniqueCode;
    // event.StatusFiveWhyAction = event.StatusFiveWhy && event.StatusFiveWhy == 'InProgress' ? 'InProgress' : statusCheck ? 'InProgress' : 'Completed';
    let iCount = 0;
    event.stageId = this.levelId ? this.levelId : this.stageId;

    const formData = new FormData();
    for (const file of this.fiveWhy) {
      if (file.UploadFile && typeof file.UploadFile === 'object') {
        formData.append('UploadFile', file.UploadFile);
        file.UploadFile = true;
        iCount++;
      }
      if (file.UploadDoc && typeof file.UploadDoc === 'object') {
        formData.append('UploadFile', file.UploadDoc);
        file.UploadDoc = true;
        iCount++;
      }
    }
    event.FyActionFileCount = iCount;
    event.CreatedBy = this.user.userCode;

    // Extract assignees from "Complete" transition for notifications
    // Only include newly completed actions for notifications
    const completeTransition = this.transitions?.find(
      (t: any) => t.actionName === 'Complete'
    );
    event.Assignees = completeTransition?.assignees?.join(',') || ''; 

    // Only set assignees if there are newly completed actions
    if (newlyCompletedActions.length > 0) {
  
      event.NewlyCompletedActionsCount = newlyCompletedActions.length;
    } else {
      event.NewlyCompletedActionsCount = 0;
    }
    
    // Track newly closed actions count
    if (newlyClosedActions.length > 0) {
      event.NewlyClosedActionsCount = newlyClosedActions.length;
    } else {
      event.NewlyClosedActionsCount = 0;
    }
    
    // Track newly rejected actions count
    if (newlyRejectedActions.length > 0) {
      event.NewlyRejectedActionsCount = newlyRejectedActions.length;
    } else {
      event.NewlyRejectedActionsCount = 0;
    }
    
    // Track newly added assignee actions count
    if (newlyAddedAssigneeActions.length > 0) {
      event.NewlyReassignedActionsCount = newlyAddedAssigneeActions.length;
    } else {
      event.NewlyReassignedActionsCount = 0;
    }

    event.Team = event.Team
      ? event.Team.filter((item) => !Number.isNaN(item))
      : '';
    formData.append('UploadFile', event.UploadFile);
    formData.append('header', JSON.stringify(event));
    formData.append('data', JSON.stringify(this.fiveWhy));
    formData.append('createdBy', JSON.stringify(this.user.userCode));
    console.log(formData, 'formData');
    let route = this.router.url;
    if (!route.includes('at/at-stages')) {
      formData.append('integrationData', JSON.stringify(integrationData));
    }

    if (this.IndividualFivewhyID)
      formData.append(
        'individualFivewhyID',
        JSON.stringify(this.IndividualFivewhyID)
      );
    this.spinnerText = 'Saving Five Why Plan Data';
    this.spinner.show();
    if (this.updateStatus) {
      this.FivewhyService.updateFiveWhyPlanData(formData).subscribe(
        (res: any) => {
          if (!res.status) {
            this.toaster.error('Error', res.message);
            this.getFiveWhyActionPlan('');
            this.spinner.hide();
            return;
          }
          this.analyticalToolsService.setHeaderId(res.data.headerId);
          this.analyticalToolsService.setStatus(this.updateStatus);
          this.analyticalToolsService.setRcaId(res.data.rcaId);
          this.toaster.success('Success', res.message);
          this.callSaveMethod = true;
          this.headerData.ID = res.data.headerId;
          this._emitHeaderData.emit(res.data);
          this.onSuccess.emit('actionPlan');
          this.getFiveWhyActionPlan('');
          this.spinner.hide();
          // this.router.navigate(['/at/fivewhy']);
          if (
            (event.StatusFiveWhyAction === 'Completed' &&
              (this.analyticalToolsService.getTableId() || 0) > 0)
          ) {
            this.saveNCRWorkflow();
          }
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error('Error', error.ErrorMessage);
        }
      );
    } else {
      this.FivewhyService.addFiveWhyActionData(formData).subscribe(
        (res: any) => {
          if (!res.status) {
            this.toaster.error('Error', res.message);
            this.getFiveWhyActionPlan('');
            this.spinner.hide();
            return;
          }
          this.analyticalToolsService.setHeaderId(res.data.headerId);
          this._emitHeaderData.emit(res.data);
          this.updateStatus = true;
          this.callSaveMethod = true;
          this.onSuccess.emit('actionPlan');
          this.analyticalToolsService.setStatus(this.updateStatus);
          this.analyticalToolsService.setRcaId(res.data.rcaId);
          this.toaster.success('Success', res.message);
          this.headerData.ID = res.data.headerId;
          this.analyticalToolsService.searchHeader;
          this.getFiveWhyActionPlan('');
          this.spinner.hide();
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error('Error', error.ErrorMessage);
        }
      );
    }
  }

  saveNCRWorkflow() {
    let tableId = this.analyticalToolsService.getTableId() || 0;
    let instanceParams = {
      // instanceKey,
      userId: this.user.userCode,
      userName: this.user.userName,
      actionName: 'update',
      workFlowKey: this.ncrWorkFlow.workFlowKey,
      tenantId: this.plantData,
      tableId: tableId,
    };

    this.workFlowService.setSingleInstance(instanceParams).subscribe(
      (res) => {
        console.log(res);
        this.updateRCAStatus();
      },
      ({ error }) => {
        this.spinner.hide();
        console.log(error?.message);
        //this.toaster.error('Error', error?.message);
      }
    );
  }

  updateRCAStatus() {
    let tableId = this.analyticalToolsService.getTableId() || 0;
    const data = { Status: 'Critical', NCRId: tableId };
    this.spinner.show();
    this.ncrService.updateRCAStatus(data).subscribe(
      (response) => {
        this.spinner.hide();
        this.toaster.success('RCA Status Updated');
      },
      ({ error }) => {
        this.spinner.hide();
        this.toaster.error(error);
      }
    );
  }

  getNCRWorkFlow(): void {
    const screenName = 'NCR';
    const ptId = this.plantData;
    this.ncrWorkFlow = [];
    this.transitions = [];
    const key = {
      screenName,
      tenantId: ptId.toString(),
      companyKey: Constants.COMPANY_KEY,
    };
    this.workFlowService.getWorkFlow(key).subscribe(
      (response) => {
        this.ncrWorkFlow = response;
        this.getWorkFlowTransitions();
      },
      ({ error }) => {
        this.spinner.hide();
        this.toaster.error('Error', error?.message);
      }
    );
  }

  getWorkFlowTransitions() {
    this.workFlowService
      .getWorkflowStatuses(this.ncrWorkFlow.workFlowKey)
      .subscribe(
        (response: any) => {
          console.log(response);
          this.transitions = response;
        },
        (err: any) => {
          console.log(err);
        }
      );
  }

  statusChange(data: any) {
    if (data.Status == 'Closed') {
      if (!data.Action) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until Action Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.ActionType) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until ActionType Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.AssignTo) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until AssignTo Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.AssignedDate) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until AssignedDate Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.TargetDate) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until TargetDate Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.RevisedDate) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until RevisedDate Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.ClosedDate) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until ClosedDate Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      } else if (!data.VerifiedBy) {
        this.toaster.warning(
          'Warning',
          `You Can't Close Status Until VerifiedBy Field Value Is Empty`
        );
        setTimeout(() => {
          data.Status = 'Open';
        }, 250);
        return;
      }
    }
  }

  openFile(i: any, type: any) {
    if (type == 'pic') this.fileInput.nativeElement.click();
    else this.fileInputFile.nativeElement.click();
    this.ind = i;
  }

  readFile(event: any, type: any) {
    this.imageFile = event.target.files[0];
    // this.fiveWhy[this.ind].UploadFile = this.imageFile;
    // this.fiveWhy[this.ind].Index = this.ind
    // this.UploadFile[this.ind].File = this.imageFile;
    // this.UploadFile[this.ind].Index = this.ind
    // this.imageFile.encoding = this.ind
    // this.UploadFile.push(this.imageFile);
    if (type == 'pic') {
      this.isAnyFileUploaded = true;
      this.fiveWhy[this.ind].UploadFile = this.imageFile;
    } else this.fiveWhy[this.ind].UploadDoc = this.imageFile;
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        if (type == 'pic') this.fiveWhy[this.ind].FileSrc = this.imageSrc;
        else {
          this.isAnyFileUploaded = true;
          this.fiveWhy[this.ind].DocSrc = this.imageSrc;
          this.fiveWhy[this.ind].base64 =
            this.domSanitizer.bypassSecurityTrustUrl(reader.result as string);
        }
      };
    }
  }

  deleteFile(i: any, type: any) {
    if (type == 'pic') {
      this.fiveWhy[i].FileSrc = '';
      this.fiveWhy[i].UploadFile = '';
    } else {
      this.fiveWhy[i].DocSrc = '';
      this.fiveWhy[i].UploadDoc = '';
      this.fiveWhy[i].base64 = '';
    }
    // this.fiveWhy[this.ind].UploadFile = '';
  }

  imageZoomModal(i: any): void {
    let imgLink: any;
    // if (this.isAnyFileUploaded) {
    //   imgLink = this.imageSrc;
    // } else {
    //   imgLink = this.blobStorageUrl + this.fiveWhy[i].UploadFile;
    // }
    // if (this.imageSrc) {
    //   imgLink = this.fiveWhy[i].FileSrc;
    // } else {
    //   imgLink = this.blobStorageUrl + this.fiveWhy[i].UploadFile;
    // }
    if (this.fiveWhy[i]?.FileSrc) {
      imgLink = this.fiveWhy[i].FileSrc;
    } else {
      imgLink = this.blobStorageUrl + this.fiveWhy[i].UploadFile;
    }
    let dialogRef = this.dialog.open(ImageDialogComponent, {
      height: '90%',
      width: '75%',
      data: imgLink,
    });
  }

  getMinDate(row: any, type: any) {
    if (type == 'Revised') {
      const date = row.RevisedDate ? row.RevisedDate : row.TargetDate;
      let currentDate = new Date(date);
      // return new Date(currentDate.setDate(currentDate.getDate() + 1))

      let minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate() + 1)
      );

      row.MinRevisedDate = (current: Date): boolean =>
        // Can not select days before today and today
        differenceInCalendarDays(current, minDateStartFrom) < 0;
      return row.MinRevisedDate;
    } else if (type == 'Target') {
      let currentDate = new Date();
      // return new Date(currentDate.setDate(currentDate.getDate() + 1))

      let minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate())
      );

      row.MinTargetDate = (current: Date): boolean =>
        // Can not select days before today and today
        differenceInCalendarDays(current, minDateStartFrom) < 0;
      return row.MinTargetDate;
    }
  }
  downloadPDF(i, fiveWhy) {
    // [href]=" yData.DocSrc || blobStorageUrl + yData.UploadDoc"
    if (fiveWhy.base64) {
      const base64 = fiveWhy.base64;
      var a = document.createElement('a'); //Create <a>
      a.href = base64?.changingThisBreaksApplicationSecurity; //Image Base64 Goes here
      a.download = 'file.pdf'; //File name Here
      a.click();
    } else {
      const base64 = fiveWhy.DocSrc;
      var a = document.createElement('a'); //Create <a>
      a.href = this.blobStorageUrl + fiveWhy.UploadDoc; //Image Base64 Goes here
      a.download = 'file.pdf';
      a.target = '_blank'; //File name Here
      a.click();
    }
  }

  /**
   * Determines whether the assignee dropdown should be disabled
   * @param yData The action plan data to check
   * @returns true if assignee selection should be disabled
   * 
   * TODO: Extract to shared ActionPlanPermissionsService (Task #XXXX)
   * This logic is duplicated across 6 components
   */
  isAssigneeDisabled(yData: ActionPlanData | null): boolean {
    if (!yData) {
      return true; // Disable if no data
    }

    // 1. Status is Closed
    if (yData.Status === ActionPlanConstants.STATUS_CLOSED) {
      return true;
    }

    // 2. Action is empty
    if (yData.Action === ActionPlanConstants.EMPTY_STRING) {
      return true;
    }

    // 3. LoggedInUser is NOT creator
    if (yData.IsLoggedInUserCreator === false) {
      return true;
    }

    // 4. ActionCompletedOn is not empty
    if (this.hasCompletionDate(yData)) {
      return true;
    }

    return false;
  }

  /**
   * Helper to check if action has a completion date
   */
  private hasCompletionDate(data: ActionPlanData): boolean {
    return !!data.ActionCompletedOn && 
           data.ActionCompletedOn !== ActionPlanConstants.EMPTY_STRING;
  }



  /**
   * Determines whether the new assignee dropdown should be disabled
   * @param yData The action plan data to check
   * @returns true if new assignee selection should be disabled
   * 
   * TODO: Extract to shared ActionPlanPermissionsService (Task #XXXX)
   * This logic is duplicated across 6 components
   */
  isNewAssigneeDisabled(yData: ActionPlanData | null): boolean {
    if (!yData) {
      return true; // Disable if no data
    }

    // 1. Status is Closed
    if (yData.Status === ActionPlanConstants.STATUS_CLOSED) {
      return true;
    }

    // 2. Verification is not Disapproved
    if (yData.Verification !== ActionPlanConstants.VERIFICATION_DISAPPROVED) {
      return true;
    }

    // 3. LoggedInUser is NOT creator
    if (yData.IsLoggedInUserCreator === false) {
      return true;
    }

    // 4. ActionCompletedOn exists but ActionCompleted is empty
    if (this.hasCompletionDate(yData) && 
        yData.ActionCompleted === ActionPlanConstants.EMPTY_STRING) {
      return true;
    }

    return false;
  }

  /**
   * Sets the assignment date and updates permission flags
   * TODO: Extract to shared ActionPlanPermissionsService (Task #XXXX)
   */
  setAssignDate(row: ActionPlanData): void {
    if (!row) {
      return;
    }

    row.AssignedDate = new Date();
    this.updateRowAssignmentFlags(row);
    
    // Case 1: Assignee = Creator AND Assignee = Logged-in user → Enable all steps
    if (row.IsAssignedToCreator && row.IsAssignedToCurrentUser) {
      return; // All steps enabled (no restrictions)
    }
    
    // Case 2: Assignee = Creator but NOT logged-in user → Don't enable ActionCompleted
    if (row.IsAssignedToCreator && row.IsAssignedToCurrentUser === false) {
      this.resetActionFields(row);
      return;
    }
    
    // Case 3: Assignee ≠ Creator but Assignee = Logged-in user → Only enable ActionCompleted
    if (row.IsAssignedToCreator === false && row.IsAssignedToCurrentUser) {
      // Reset verification fields since this user is not the creator
      this.resetVerificationFields(row);
      return;
    }
    
    // Default case: Reset all fields
    this.resetActionFields(row);
  }

  /**
   * Resets all action and verification fields
   */
  private resetActionFields(row: ActionPlanData): void {
    row.ActionCompleted = ActionPlanConstants.COMPLETION_NO;
    row.ActionCompletedBy = ActionPlanConstants.EMPTY_STRING;
    row.ActionCompletedOn = ActionPlanConstants.EMPTY_STRING;
    this.resetVerificationFields(row);
  }

  /**
   * Resets verification fields only
   */
  private resetVerificationFields(row: ActionPlanData): void {
    row.Verification = ActionPlanConstants.EMPTY_STRING;
    row.VerificationBy = ActionPlanConstants.EMPTY_STRING;
    row.VerificationOn = ActionPlanConstants.EMPTY_STRING;
  }

  /**
   * Updates assignment permission flags for a row
   * TODO: Extract to shared ActionPlanPermissionsService (Task #XXXX)
   */
updateRowAssignmentFlags(row: ActionPlanData): void {
  if (!row) {
    return;
  }

  // Use NewAssignee if available, otherwise fall back to AssignTo
  const effectiveAssignee =
    row.NewAssignee != null && row.NewAssignee !== ''
      ? row.NewAssignee
      : row.AssignTo;

  row.IsAssignedToCreator =
    effectiveAssignee == null || row.CreatedBy == null
      ? undefined
      : effectiveAssignee === row.CreatedBy;

  row.IsAssignedToCurrentUser =
    effectiveAssignee == null || this.user?.userCode == null
      ? undefined
      : effectiveAssignee === this.user.userCode;

  row.IsLoggedInUserCreator =
    this.user?.userCode == null || row.CreatedBy == null
      ? undefined
      : this.user.userCode === row.CreatedBy;
}

  updateAllRowsAssignmentFlags() {
    if (this.fiveWhy && this.fiveWhy.length) {
      this.fiveWhy.forEach((row: any) => {
        this.updateRowAssignmentFlags(row);
      });
    }
  }

  onRevisedDateChange(row: any) {
    if (row.MissesCondition) {
      row.NoOfMisses++;
      row.MissesCondition = false;
    } else if (!row.MissesCondition && !row.RevisedDate) {
      row.NoOfMisses--;
      row.MissesCondition = true;
    }
    // row.MinRevisedDate = (current: Date): boolean =>
    // // Can not select days before today and today
    // differenceInCalendarDays(current, new Date(row.TargetDate)) < 0;
  }

  ActionCompletedChange(row: ActionPlanData): void {
    if (!row) {
      return;
    }

    this.updateRowAssignmentFlags(row);
    
    if (row.ActionCompleted === ActionPlanConstants.COMPLETION_YES) {
      row.ActionCompletedBy = this.user.userCode;
      row.ActionCompletedOn = new Date();
      
      // Only clear Verification, don't allow non-creators to set it
      if (row.IsAssignedToCreator === false) {
        row.Verification = ActionPlanConstants.EMPTY_STRING;
        row.VerificationBy = ActionPlanConstants.EMPTY_STRING;
        row.VerificationOn = null;
      } else {
        row.Verification = ActionPlanConstants.EMPTY_STRING;
      }
    } else {
      row.ActionCompletedBy = ActionPlanConstants.EMPTY_STRING;
      row.ActionCompletedOn = null;
      row.Verification = ActionPlanConstants.EMPTY_STRING;
      row.VerificationBy = '';
      row.VerificationOn = null;
    }
  }

  VerificationChange(row: any) {
    // if (row.Verification == 'Approved') {
    row.VerificationBy = this.user.userCode;
    row.VerificationOn = new Date();
    // }
    // else if (row.Verification == 'Disapproved') {
    //   row.VerificationBy = '';
    //   row.VerificationOn = null;
    // }
    
    // Clear remarks requirement flag when verification changes
    if (row.Verification !== 'Disapproved') {
      row.remarksRequired = false;
    } else {
      row.remarksRequired = true;
    }
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  getMClassificationList() {
    this.actionplanService.getMClassification().subscribe(
      (response) => {
        this.mClassificationTypes = response;
      },
      (error) => {
        this.toaster.error('Error', 'Something Went Wrong');
      }
    );
  }
}
